import { render, staticRenderFns } from "./RoleTable.vue?vue&type=template&id=2fc67965&scoped=true&"
import script from "./RoleTable.vue?vue&type=script&lang=ts&"
export * from "./RoleTable.vue?vue&type=script&lang=ts&"
import style0 from "./RoleTable.vue?vue&type=style&index=0&id=2fc67965&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc67965",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCheckbox,VImg,VSimpleTable})
